/* @ngInject */
function AnalyticsFilterSelectController ($scope) {
  const api = {}

  this.getApi = () => api

  activate()

  function activate () {}

  $scope.onClick = (newOption) => {
    if (newOption.disabled || newOption.active) {
      return
    }

    $scope.options.forEach(option => {
      if (option.value === newOption.value) {
        option.active = true
      } else {
        option.active = false
      }
    })

    $scope.onFilterChange({
      option: newOption
    })
  }
}

export { AnalyticsFilterSelectController }
